import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { NoteDetails, UseNotesApi } from "../common/notes";
import { HospitalistContext } from "../../core/hospitalist-context";
import { useState } from "react";

type NotesSummaryProps = {
  api: UseNotesApi;
  hospitalistContext: HospitalistContext;
};

export function NoteSummary(props?: NotesSummaryProps) {
    const { useNotes } = props.api;
    const notes = useNotes((s) => s.notes);
    const noteContexts = Object.entries(notes);
    
    const [open, setOpen] = useState(true);
    const close = () => {
        setOpen(false);
    }
    return (
        <Dialog
            open={open}
            maxWidth={false}
            onClose={close}
            PaperProps={{
                style: {
                width: '500px',
                maxHeight: '50vh',
                },
            }}
            >
        <DialogTitle>
            <div
            style={
                {
                display: 'flex',
                direction: 'row',
                alignItems: 'flex-end',
                height: '30px',
                } as any
            }
            >
            Coder Notes
            </div>
        </DialogTitle>

        <DialogContent style={{ zIndex: 1501 }}>
            {noteContexts.map((e) => (
                <Grid
                    container
                    key={e[0]}
                    item
                    direction="column"
                    spacing={1}
                    style={{ width: '100%' }}
                >
                    
                    {e[1].map((v, i) => (
                    <Grid item key={e[0] + i} style={{ paddingLeft: '0px' }}>
                        <NoteDetails coderNote={v} context={e[0] as string} api={props.api} />
                    </Grid>
                    ))}
                </Grid>
                ))}
        </DialogContent>

        <DialogActions>
            <Button variant="outlined" color="primary" onClick={close}>
            Cancel
            </Button>
        </DialogActions>
        </Dialog>
    )
}